import { useURLControlHook } from "./useURLControlHook";

export default useURLControlHook;
